import spoSchedItemInitialValue from './createItemInitialValue'

const initialValue = () => ({
  poOptions: [],
  items: [spoSchedItemInitialValue],
})

export default initialValue
